"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SESSION = exports.UTILS = exports.ULOG = exports.SHARE = exports.WECHAT = exports.ROUTE = void 0;
// 统跳
var ROUTE = {
  // 登录
  login: 'wlqq://activity/login?post_login_behavior=2',
  // 钱包
  wallet: 'wlqq://activity/wallet?flag=true',
  // web统跳 ?url=xxxx
  web: 'wlqq://activity/common_web',
  // web安卓全屏统跳 &url=xxxx
  webAndroidFull: 'wlqq://activity/h5full?fullscreen=true',
  // web ios全屏统跳 &url=xxxx
  webIosFull: 'wlqq://activity/common_web?fullscreen=true',
  // 支付?_flag_=true&orderNo=xxxx&shopNo=xxxx
  pay: 'wlqq://activity/payment?_flag_=true'
}; // 微信公众号

exports.ROUTE = ROUTE;
var WECHAT = {
  appId: 'wx3d32f8f472bd7bcb',
  // 活动中心获取微信config数据接口
  ticketApi: 'https://shareact.56qq.com/web/wx/getJsApiTicket',
  // 微信js资源url
  wxJsUrl: 'https://res.wx.qq.com/open/js/jweixin-1.0.0.js',
  // 默认注册api
  apiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone'],
  // 授权链接
  auth: {
    url: 'https://s.56qq.com/mBase/wlqq/WxCode.html',
    host: {
      DEV: 'http://activity-gy.qa-ag.56qq.com',
      STAGE: 'https://activity.56qq.com',
      PROD: 'https://activity.56qq.com'
    },
    path: '/web/wechat/get-openid',
    diff: 86400000
  }
}; // app内分享

exports.WECHAT = WECHAT;
var SHARE = {
  // 默认分享平台
  platforms: ['Wechat', 'WechatMoments', 'QQ', 'QZone']
}; // 埋点

exports.SHARE = SHARE;
var ULOG = {
  host: {
    DEV: 'https://ulog-service.dev.56qq.cn',
    STAGE: 'https://ulog-service.56qq.com',
    PROD: 'https://ulog-service.56qq.com'
  },
  path: '/web/clientlog/save.do'
}; // 工具

exports.ULOG = ULOG;
var UTILS = {
  setTileSrc: 'https://s.56qq.com/mBase/wlqq/dist/20170421/images/loading.png',
  vconsoleUrl: 'https://s.56qq.com/mBase/wlqq/dist/20170421/js/vconsole.js',
  QRCodeUrl: 'https://s.56qq.com/mBase/wlqq/dist/20170421/js/QRCode.js'
}; // SESSION

exports.UTILS = UTILS;
var SESSION = {
  url: 'http://sso.qa-ag.56qq.com/common/web/mobile/login-by-code.do',
  code: 8888,
  isPwdEncrypt: 0,
  codeType: 1,
  driver: {
    domainId: 1,
    appClientId: 207
  },
  consignor: {
    domainId: 1,
    appClientId: 180
  },
  admin: {
    domainId: 1,
    appClientId: 110
  }
};
exports.SESSION = SESSION;